    <!--未完善，有空再改-->
<template>
    <div class="upTemp">
        <div class="upDiv" v-if="acType===1">
            <el-upload
                    class="formInput upload-demo fiFiles" ref="upload_path" :action="oss.host"
                    :data="upload_data" :on-preview="handlePreview" :on-remove="handleRemove"
                    :before-remove="beforeRemove" :before-upload="beforeUpload" :multiple="limit>1"
                    :on-success="handleSuccess" :on-error="handleUploadError" :on-progress="handleProgress"
                    :on-change="handleChange" :limit="limit" :file-list="fileName"
                    :list-type="acType===1?'picture-card':'text'" :disabled="disabled"
                    :on-exceed="handleExceed"
                    :accept="getAcceptType()"
            >
                <!-- <el-button v-if="acType===2" size="small" class="ac2Btn" :disabled="disabled" type="success">上传文件</el-button> -->
                <i class="el-icon-plus" :class="disabled?'disabled':''"  v-if="acType===1"></i>
            </el-upload>
            <i class="el-icon-paperclip file cursorPointer annex" v-if="annex"></i>
        </div>
        <div class="upDiv widthRegular" v-if="acType===2">
            <!-- <el-upload
                    class="formInput upload-demo fiFiles" ref="upload_path" :action="oss.host"
                    :data="upload_data" :on-preview="handlePreview" :on-remove="handleRemove"
                    :before-remove="beforeRemove" :before-upload="beforeUpload" :multiple="limit>1"
                    :on-success="handleSuccess" :on-error="handleUploadError" :on-progress="handleProgress"
                    :on-change="handleChange" :limit="limit" :file-list="initList"
                    :list-type="acType===1?'picture-card':'text'" :disabled="disabled"
                    :on-exceed="handleExceed"
                    :accept="getAcceptType()"
            >
                <el-button v-if="acType===2" size="small" class="ac2Btn" :disabled="disabled" type="success">上传文件</el-button>
                <i class="el-icon-plus" :class="disabled?'disabled':''"  v-if="acType===1"></i>
            </el-upload> -->
            <!-- <div class="" style="border: 1px dashed #d9d9d9;padding: 60px 160px;border-radius: 6px;"> -->
                <el-upload  class="formInput upload-demo " ref="upload_path" :action="oss.host" drag
                    :data="upload_data" :on-preview="handlePreview" :on-remove="handleRemove"
                    :before-remove="beforeRemove" :before-upload="beforeUpload" :multiple="limit>1"
                    :on-success="handleSuccess" :on-error="handleUploadError" :on-progress="handleProgress"
                    :on-change="handleChange" :limit="limit" :file-list="fileName"
                    :list-type="acType===1?'picture-card':'text'" :disabled="disabled"
                    :on-exceed="handleExceed"
                    :accept="getAcceptType()">
                    <img src="/icon/upfile.png" class="uploadFileAdd">
                    <div class="el-upload__text"  style="font-size:12px; color:#333;">将文件拖到此处，或<em style="color: #b21111;">点击上传</em></div>
                </el-upload>
                <i class="el-icon-paperclip file cursorPointer annex" v-if="annex"></i>
            <!-- </div> -->
        </div>
        <el-dialog class="eldialog" custom-class="full_dialog" :modal="false" v-dialog-drag :title="'预览'+previewObj.name" :visible.sync="previewDialog">
            <img :src="previewObj.url" :alt="previewObj.name" style="max-width: 600px;">
        </el-dialog>
    </div>
</template>

<script>
    export default {
        props: {
            acType: {
                type: Number,
                default: 1,//接收的文件类型 1=只有图片（默认） 2=文件+图片+视频等
            },
            limit: {
                type: Number,//最大文件数
                default: 1
            },
            initList: {
                type:Array
            },
            formParam: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            disabled: Boolean,//禁用状态
            annex: Boolean,//附件
            crop: Boolean,//裁剪
        },
        data() {
            return {
                oss: {
                    host:''
                },
                upload_data: {},
                previewDialog:false,
                previewObj:{
                    url:'',
                    name:''
                },
                files: this.formParam,
                fileName:this.initList,
                newFiles:[],
                removeFiles:[],
            };

        },
        methods: {
            getAcceptType() {
                let a1 = '.jpg,.jpeg,.png,.gif,.bmp,.pbg,.svg,.ico';
                if (this.acType === 1) {
                    return a1;
                }else{
                    return a1+',.ogv,.mp4,.ogg,.webm,.wav,.mp3,.acc,.amr,.txt,.pdf,.doc,.docx,.xlsx,.xls,.conf,.ini,.zip';
                }
            },
            handlePreview(file) {
                console.log(file)
                this.previewObj.name = file.name;
                if (file.response) {
                    this.previewObj.url = file.response.data.base_url;
                }else{
                    this.previewObj.url = file.url;
                }
                if (this.$isImgFile(file.name)) {
                    this.previewDialog = true;
                }else if (this.$isWinpFile(file.name)) {
                    window.open(this.previewObj.url);
                }
            },
            showPlusCard(bool) {
                let disType = bool ? 'inline-block' : 'none';
                this.$nextTick(() => {
                    let btn = this.$el.querySelector(".fiFiles .el-upload.el-upload--picture-card");
                    if (btn) {
                        btn.style = `display:${disType}`;
                    }
                });
            },
            checkShowPlusCardWithFiles(fl = this.files.length) {
                if (this.acType === 1) {
                    //图片卡片模式
                    let bool = fl < this.limit && !this.disabled;
                    this.showPlusCard(bool);
                } else if (this.acType === 2) {
                    this.switchImgIcon();//切换图标
                }
            },
            handleRemove(file,fileList) {
                if (file.response) {
                    this.files = this.files.filter(a => a !== file.response.data.base_url);
                }else{
                    this.files = this.files.filter(a => a !== file.url);
                }
                this.removeFiles = fileList;
            },
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${ file.name }？`);
            },
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            beforeUpload(file) {
                return this.$getOss(file);
            },
            handleUploadError() {
            },
            handleProgress(e, file, fileList) {
            },
            handleChange(file,fileList) {
            },
            handleSuccess(res,fileList ) {
                this.files.push(res.data.base_url);
                this.newFiles.push(res.data)
                this.tip("文件上传成功", "success");
            },
            switchImgIcon() {
                this.$nextTick(() => {
                    let docs = this.$el.querySelectorAll('.fiFiles .el-upload-list__item i.el-icon-document');
                    docs.forEach(item=>{
                        let file_name = item.parentNode['innerText'];
                        item.parentNode.title = file_name;
                        if (this.$isImgFile(file_name)) {
                            item.className = "el-icon-picture";
                        }
                    });
                });
            },
        },
        watch:{
            "formParam": {
                immediate: true,
                deep:true,
                handler:function (val) {
                    this.files = val;
                }
            },
            "initList":{
                immediate: true,
                deep:true,
                handler:function (val) {
                    this.fileName = val;
                }
            },
            "files":{
                immediate:true,
                deep:true,
                handler:function (val) {
                    this.checkShowPlusCardWithFiles();//检查是否显示上传卡片按钮
                    this.$emit("update:formParam", val);
                    // this.$emit("getFileData",val)
                }
            },
            "newFiles":{
                immediate:true,
                deep:true,
                handler:function (val) {
                    let arrnew = val.map((item,index) => {
                        return Object.assign({},{'url':item.base_url,"name":item.filename})
                    })
                    this.$emit("getFileData",arrnew)
                }
            },
            "removeFiles":{
                immediate:true,
                deep:true,
                handler:function (val) {
                    let arrnew = val.map((item,index) => {
                        return Object.assign({},{'url':item.url,"name":item.name})
                    })
                    this.$emit("getFileData",arrnew)
                }
            },
            "disabled":function () {
                this.checkShowPlusCardWithFiles();
            },
            "limit":function () {
                this.checkShowPlusCardWithFiles();
            },
            "acType":function () {
                this.checkShowPlusCardWithFiles();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .upTemp{
        display: inline-block;
    }
    .upDiv {
        position: relative;
    }
    .upDiv .fiFiles{
        text-align: left;
    }
    .widthRegular{width: 500px;}
    .fiFiles .ac2Btn{
        margin-left: 22px;
    }
    .fiFiles /deep/ .el-upload--picture-card i.el-icon-plus{
        padding: 5px 12px;
    }
    .fiFiles  /deep/ .el-upload--picture-card i.el-icon-plus.disabled{
        cursor: not-allowed;
    }
    .upDiv /deep/ .annex{
        position: absolute;
        right: -25px;
        top: 50%;
        transform: translateY(-50%);
    }
    .fiFiles /deep/ .el-upload-list--picture-card .el-upload-list__item{
        width:55px;
        height: 35px;
    }
    .fiFiles /deep/ .el-upload.el-upload--picture-card{
        width:55px;
        height: 35px;
        line-height: 35px;
    }
    .fiFiles /deep/ .el-upload-list--picture-card .el-upload-list__item-actions span + span{
        margin-left: 5px;
    }
    .fiFiles /deep/ .el-upload.el-upload--picture-card .el-button.el-button--small{
        font-size: 8px;
        padding: 2px 5px;
    }
    .fiFiles /deep/ .el-upload--picture-card i{
        font-size: 18px;
    }
    .fiFiles /deep/ .el-upload-list__item.is-success:focus:not(:hover) .el-icon-close-tip{
        display: none;
    }
    .fiFiles /deep/ .el-upload-list__item i.el-icon-picture {
        color: #3b8bff;

    }
    .uploadFileAdd{margin: 40px 0 20px 0;}
</style>